import { render, staticRenderFns } from "./apark.vue?vue&type=template&id=4960de4c&scoped=true&"
import script from "./apark.vue?vue&type=script&lang=js&"
export * from "./apark.vue?vue&type=script&lang=js&"
import style0 from "./apark.vue?vue&type=style&index=0&id=4960de4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4960de4c",
  null
  
)

export default component.exports